import { h, Component } from "preact";

import agua from "../img/agua.svg";
import amostragem from "../img/amonstragem.svg";
import biomassa from "../img/biomassa.svg";
import diagnostico from "../img/diagnostico.svg";
import mapeamentos from "../img/mapeamento.svg";
import solo from "../img/solo.svg";

import { Text } from "preact-i18n";

class WhatWeOffer extends Component {
  render() {
    return (
      <div id={this.props.id} class="uk-container"
        style={{ paddingTop: "4.2em" }}
      >
        <div class="uk-width-xlarge uk-margin-auto uk-text-center uk-margin-large-bottom">

          <h2 class="uk-h1 uk-margin-top">
            <Text id="WhatWeOffer.title">Características</Text>
          </h2>
          <p class="uk-text-large tm-text-large">
            <Text id="WhatWeOffer.subtitle">
              Monitorizando continuamente o território.
            </Text>
          </p>
        </div>

        <div
          uk-grid
          class="uk-child-width-4-4@m uk-child-width-1-3@s uk-grid uk-grid-match"
          uk-scrollspy="target: > div; cls: uk-animation-fade; delay: 500"
        >
          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="110"
                  height="125"
                  src={biomassa}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">
                <h3 class="uk-card-title">
                  <Text id="WhatWeOffer.a1.title">Biomassa</Text>
                </h3>

                <div>
                  <Text id="WhatWeOffer.a1.text">
                    Evolução e intensidade da biomassa no espaço e no tempo
                    (aplicações na quantidade de biomassa existente, produtividade,
                    carbono…).
                  </Text>
                </div>

              </div>
            </div>
          </div>

          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="80"
                  height="100"
                  src={agua}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">
                <h3 class="uk-card-title">
                  <Text id="WhatWeOffer.a2.title"> Água</Text>
                </h3>
                <div>
                  <Text id="WhatWeOffer.a2.text">Teor de água na folha e sua relação com o stress hídrico das plantas
                  (aplicações na rega e risco de fogos de incêndios).</Text>
                </div>

              </div>
            </div>
          </div>

          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="80"
                  height="125"
                  src={mapeamentos}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">

                <h3 class="uk-card-title">
                  <Text id="WhatWeOffer.a3.title"> Mapeamento</Text>
                </h3>


                <div>
                  <Text id="WhatWeOffer.a3.text">
                    Mapeamento da qualidade e quantidade de água existente nas albufeiras
                    (cálculos da reserva hídrica existente, estudos de qualidade da água;
                    estudos de invasoras aquáticas…).
                  </Text>
                </div>

              </div>
            </div>
          </div>


          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="100"
                  height="125"
                  src={solo}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">
                <h3 class="uk-card-title">

                  <Text id="WhatWeOffer.b1.title"> Solo</Text>
                </h3>
                <div>
                  <Text id="WhatWeOffer.b1.text">Mapeamento da qualidade do solo (uso e gestão diferenciada do mesmo…).</Text>
                </div>

              </div>
            </div>
          </div>

          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="50"
                  height="75"
                  //src="https://image.flaticon.com/icons/svg/498/498234.svg"
                  src={amostragem}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">
                <h3 class="uk-card-title ">

                  <Text id="WhatWeOffer.b2.title"> Amostragens</Text>
                </h3>
                <div>
                  <Text id="WhatWeOffer.b2.text">
                    Desenvolvimento de amostragens dirigidas sobre o território.
                  </Text>
                </div>

              </div>
            </div>
          </div>


          <div class="uk-grid-margin uk-text-center">
            <div class="uk-card uk-card-default">
              <div class="uk-text-center" style={{ paddingTop: "40px" }}>
                <img
                  uk-svg
                  width="100"
                  height="125"
                  src={diagnostico}
                  alt="Sonic Style"
                />
              </div>
              <div class="uk-card-body">
                <h3 class="uk-card-title">

                  <Text id="WhatWeOffer.b3.title"> Diagnóstico</Text>
                </h3>
                <div>
                  <Text id="WhatWeOffer.b3.text">
                    Controle, avaliação e diagnóstico precoce de problemas em campo.
                  </Text>
                </div>



              </div>
            </div>
          </div>
        </div>



        <hr class="uk-margin-remove-bottom uk-margin-xlarge-top" />
      </div>
    );
  }
}

export default WhatWeOffer;
